import { render, staticRenderFns } from "./VuesticWizard.vue?vue&type=template&id=db872068&scoped=true"
import script from "./VuesticWizard.vue?vue&type=script&lang=js"
export * from "./VuesticWizard.vue?vue&type=script&lang=js"
import style0 from "./VuesticWizard.vue?vue&type=style&index=0&id=db872068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db872068",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-wizard/VuesticWizard.vue
// module id = aHv1
// module chunks = 41